import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a97977c6d471300143c8951_1788323506588_909d6448/qrcattleform/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a97977c6d471300143c8951_1788323506588_909d6448/qrcattleform/src/app/components/AdhesionFormContainer.tsx");
